import Page from '../Shared/Page/Page';

export default function Faq() {
	return (
		<Page title='FAQs'>
			<p>
				Under Construction, theres probably a lot of questions right
				now.
			</p>
		</Page>
	);
}
